import apiCaller from "../../../helper/apiCall";
import { CHECKER_ENDPOINTS } from "../../urls/endpoints";

const fetchCheckerDashboardCards = async (params = {}) => {
  const response = await apiCaller(
    CHECKER_ENDPOINTS.DASHBOARD_CARDS,
    "GET",
    params
  );
  return response;
};
const fetchCheckerFarmerList = async (params) => {
  const dataToSend = {
    type: params.type || "asc",
    currentPage: params.currentPage || 1,
    search: params.search || "",
    searchCol: params.searchCol || "",
    sortCol: params.sortCol || "",
    programCode: params.programCode || "",
    filters: params.filters || {},
    ...params,
  };

  const response = await apiCaller(
    CHECKER_ENDPOINTS.FARMER_LIST,
    "POST",
    dataToSend
  );
  return response;
};

const fetchCheckerFarmerDetails = async (params) => {
  const response = await apiCaller(
    CHECKER_ENDPOINTS.FARMER_DETAILS,
    "POST",
    params
  );
  return response;
};

const verifyFarmer = async (data) => {
  const response = await apiCaller(
    CHECKER_ENDPOINTS.VERIFY_FARMER,
    "POST",
    data
  );
  return response;
};

const revertFarmer = async (data) => {
  const response = await apiCaller(
    CHECKER_ENDPOINTS.REVERT_FARMER,
    "PUT",
    data
  );
  return response;
};

const fetchCheckerProfile = async (data) => {
  const response = await apiCaller(CHECKER_ENDPOINTS.VIEW_PROFILE, "POST", data );
  return response;
};

const updateCheckerProfile = async (data) => {
  const response = await apiCaller(CHECKER_ENDPOINTS.UPDATE_PROFILE, "PUT", data);
  return response;
};

export {
  fetchCheckerDashboardCards,
  fetchCheckerFarmerList,
  fetchCheckerFarmerDetails,
  verifyFarmer,
  revertFarmer,
  fetchCheckerProfile,
  updateCheckerProfile,
};
